import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { deleteProduct } from '../../../store/actions/productActions';
import { Link, withRouter } from 'react-router-dom';
import { firestore } from '../../../config/firebase';
import defaultCarpetImg from '../../../assets/img/default/carpet.svg';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import QRCodeComponent from '../../QRCode/QRCode';
import Swal from 'sweetalert2';
import './ProductDetails.css';
import axios from 'axios';
import lang from './lang';
const Users = firestore.collection('users');
const siteUrl = 'https://api.carpetking.uz';

class ProductDetails extends Component {
    state = { toggleBtn: false, msg: '', msgStatus: false, msgType: 'success' }
    componentDidMount() {
        const { id } = this.props.match.params;
        const currentProduct = this.props.products.find(product => product.id === id);
        if (currentProduct) {
            // If the previouse page is from new products page add img modified 
            const modifiedImg = this.props.history.state ? currentProduct.img + '?m=' + new Date().getTime() : currentProduct.img;

            this.setState({ ...currentProduct, msgStatus: false, img: modifiedImg });
        } else {
            this.setState({
                msg: 'Sorry! There is no product with the code',
                msgStatus: true,
                msgType: 'danger'
            });
        }
    }

    alertMessageHandler = () => {
        this.setState({ msgStatus: false });
    }

    deleteProductHandler = (id) => {
        // Alert Messages
        const { alert } = lang[this.props.user.lang];

        Swal.fire({
            title: alert.title,
            text: alert.text,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonText: alert.cancel,
            cancelButtonColor: '#d33',
            confirmButtonText: alert.yesBtn
        }).then((result) => {
            if (result.value) {
                Users.doc(this.props.user.id)
                    .collection('products').doc(id).delete()
                if (this.state.img) {
                    // var imgUrl = storage.refFromURL(this.state.img);
                    // imgUrl.delete()
                    //     .then(() => {
                    //         console.log('successfully deleted')
                    //     })
                    //     .catch(err => this.setState({ msgStatus: true, msgType: 'danger', msg: err.message }))
                    let url = '';
                    if (process.env.NODE_ENV !== 'development') {
                        url = siteUrl + '/products/img/delete';
                    } else {
                        url = '/products/img/delete';
                    }

                    axios.post(url, { url: this.state.img })
                        .then(res => console.log(res.data))
                        .catch(err => console.log(err))
                }

                this.setState({ msg: 'The product has been removed', msgStatus: true });
                // Redux delete current product
                this.props.deleteCurrentProduct(id);

                setTimeout(() => {
                    this.props.history.push('/products')
                }, 1000)
            }
        })
    }

    componentDidUpdate(prevProps, prevState) {
        const { id } = this.props.match.params;
        if (prevState.id !== id) {
            const currentProduct = this.props.products.find(product => product.id === id);
            if (currentProduct) {
                return this.setState({ ...currentProduct })
            }
        }
    }

    render() {
        const {
            design,
            quality,
            title,
            category,
            color,
            dimension,
            total,
            importPrice,
            salePrice,
            inStock,
            info,
            buttons: { edit, deleteBtn, sale }
        } = lang[this.props.user.lang || 'en'];
        if (this.state.id) {
            return (
                <div>
                    <div
                        className={`alert alert-${this.state.msgType}`}
                        style={{ display: this.state.msgStatus ? 'block' : 'none' }}
                    >{this.state.msg}
                        <button type="button" className="close" onClick={() => this.alertMessageHandler()}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="container bg-white pt-1" id="product-details-page">
                        <div className="media mt-5 row">
                            <div className="align-self-start col-md-4">
                                <img
                                    src={this.state.img || defaultCarpetImg}
                                    onError={(event) => event.target.src = defaultCarpetImg}
                                    className="align-self-start mr-3 w-100 product-img"
                                    alt={this.state.name}
                                />
                                {
                                    this.props.auth.isAdmin ? (
                                        <div className="my-3 text-center d-flex flex-wrap align-items-center justify-content-center action-group">
                                            <Link className="btn btn-sm btn-outline-success btn-sm mr-2" to={`/products/${this.state.id}/edit`}><FiEdit /> {edit}</Link>
                                            <span className="btn btn-sm btn-outline-danger btn-sm mr-2 my-2"
                                                onClick={(id) => this.deleteProductHandler(this.state.id)}
                                            ><FiTrash2 />{deleteBtn}</span>
                                            <QRCodeComponent data={this.state.id} numberOfItems={2} lang={this.props.user.lang} productName={this.state.code} />
                                        </div>
                                    ) : null
                                }

                            </div>
                            <div className="media-body col-md-8">
                                <h3 className="mt-3 mb-0 product-title">
                                    <span className="text-uppercase">{this.state.name}</span>
                                    <span id="price-tag">{this.props.user.currency === 'UZS' ? parseInt(this.state.totalMerchantPrice * this.props.user.uzsAmount).toLocaleString() : this.state.totalMerchantPrice} <sup>{this.props.user.currency}</sup></span>
                                </h3>
                                <p className="border-bottom company-name">{this.state.brand}</p>
                                <h5>{title}</h5>
                                <table className="table table-sm table-bordered">
                                    <tbody>
                                        <tr>
                                            <td>{design}:</td>
                                            <th><span className="main-info">{this.state.code}</span></th>
                                        </tr>
                                        <tr>
                                            <td>{quality}:</td>
                                            <th className="text-capitalize"><span className="main-info">{this.state.quality}</span></th>
                                        </tr>
                                        <tr>
                                            <td>{category}:</td>
                                            <th className="text-capitalize"><span className="main-info">{this.state.category}</span></th>
                                        </tr>
                                        <tr>
                                            <td>{color}:</td>
                                            <th id="color-th" className="d-flex align-items-center"><span className="main-info">{this.state.color}</span> <span className="color-style" style={{ background: this.state.colorCode }}></span></th>
                                        </tr>
                                        <tr>
                                            <td>{dimension}:</td>
                                            <th><span className="main-info">{this.state.width}</span> x <span className="main-info">{this.state.lengthLong}</span> m</th>
                                        </tr>
                                        <tr>
                                            <td>{total} m<sup>2</sup>:</td>
                                            <th><span className="main-info">{this.state.totalSize}</span> m<sup>2</sup> </th>
                                        </tr>
                                        {
                                            this.props.auth.isAdmin ?
                                                (<tr>
                                                    <td>{importPrice}:</td>
                                                    <th><span className="main-info">{this.props.user.currency === 'UZS' ? parseInt(this.state.factoryPrice * this.props.user.uzsAmount).toLocaleString() : this.state.factoryPrice}</span> {this.props.user.currency}/m<sup>2</sup></th>
                                                </tr>)
                                                :
                                                null
                                        }

                                        <tr>
                                            <td>{salePrice}:</td>
                                            <th><span className="main-info">{this.props.user.currency === 'UZS' ? parseInt(this.state.merchantPrice * this.props.user.uzsAmount).toLocaleString() : this.state.merchantPrice}</span> {this.props.user.currency}/m<sup>2</sup></th>
                                        </tr>
                                        <tr>
                                            <td>{inStock}:</td>
                                            <th><span className="main-info">{this.state.roll !== 0 ? this.state.roll : this.state.piece}</span></th>
                                        </tr>
                                    </tbody>

                                </table>
                                <h5 className="my-3">{info}</h5>
                                <p className="note">
                                    {this.state.content}
                                </p>
                                <div className="text-center my-4">
                                    {
                                        this.state.piece > 0 ?
                                            (<Link to={'/sales/' + this.state.id + '/sale'} className="btn btn-success btn-lg btn-sm rounded-pill px-4">{sale}</Link>)
                                            :
                                            null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div
                    className={`alert alert-${this.state.msgType}`}
                    style={{ display: this.state.msgStatus ? 'block' : 'none' }}
                >{this.state.msg}
                    <button type="button" className="close" onClick={() => this.alertMessageHandler()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            )
        }

    }
}


ProductDetails.propTypes = {
    products: PropTypes.array.isRequired
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
        currency: state.currency,
        user: state.user,
        products: state.products.products,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        deleteCurrentProduct: (id) => dispatch(deleteProduct(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductDetails));